import { call, put, all, takeLatest } from "redux-saga/effects";

import { getTimeConfirmPeriodAPI } from "core/http/service/timeKeeping";
import {
  getTimeConfirmPeriodFailed,
  getTimeConfirmPeriodStart,
  getTimeConfirmPeriodSuccess,
} from "../redux/getTimeConfirmPeriod";

function* getTimeConfirmPeriodWork(action) {
  const data = {
    ...action.payload,
  };

  try {
    const res = yield call(getTimeConfirmPeriodAPI, data);
    if (res) {
      yield put({
        type: getTimeConfirmPeriodSuccess.type,
        payload: res,
      });
    }
  } catch (err: any) {
    yield put({
      type: getTimeConfirmPeriodFailed.type,
    });
  }
}

function* watchGetTimeConfirmPeriod() {
  yield takeLatest(getTimeConfirmPeriodStart.type, getTimeConfirmPeriodWork);
}

export default function* getTimeConfirmPeriodSaga() {
  yield all([watchGetTimeConfirmPeriod()]);
}
